import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckItem } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useCurrentOrgRootPath } from '../organization/useOrg'
import { PagedOrgForm } from '../survey/PagedOrgForm'
import { FORM_NAME, FORM_VERSION, PAGES } from './config'
import { usePayrollOpsSurveyStatus } from './usePayrollOpsSurveyStatus'

type PayrollOpsSurveyHealthcheckProps = {
  org: OrganizationDetailFragment
  todo?: boolean
}

export const PayrollOpsSurvey = () => {
  return (
    <PagedOrgForm
      formName={FORM_NAME}
      formVersion={FORM_VERSION}
      pages={PAGES}
      onCompleteReturnTo="payroll"
    />
  )
}

export const PayrollOpsSurveyHealthcheck = ({ org, todo }: PayrollOpsSurveyHealthcheckProps) => {
  const statusResult = usePayrollOpsSurveyStatus(org, todo)
  const currentOrgRootPath = useCurrentOrgRootPath()

  return (
    <HealthcheckItem
      to={`${currentOrgRootPath}/payroll/survey`}
      primary="Payroll connection"
      secondary={statusResult.secondary}
      todo={todo}
      status={statusResult.status}
    >
      <PagedOrgForm
        formName={FORM_NAME}
        formVersion={FORM_VERSION}
        pages={PAGES}
        onCompleteReturnTo={todo ? 'payroll' : undefined}
      />
    </HealthcheckItem>
  )
}
